<template>
    <div class="bot-manager">
        <div class="search-section">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item label="BOT用户名">
                    <el-input v-model="searchForm.botname" placeholder="请输入机器人用户名（@开头）" clearable size="large"
                        style="width: 200px" />
                </el-form-item>
                <el-form-item>
                    <div class="button-group">
                        <el-button type="primary" @click="onSearch" size="large">
                            <el-icon>
                                <Search />
                            </el-icon>搜索
                        </el-button>
                        <el-button @click="resetSearch" size="large">
                            <el-icon>
                                <Refresh />
                            </el-icon>重置
                        </el-button>
                        <el-button type="success" @click="showCreateDialog" size="large">
                            <el-icon>
                                <Plus />
                            </el-icon>新增机器人
                        </el-button>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <el-divider></el-divider>
        <el-table :data="tableData" style="width: 100%" v-loading="loading">
            <el-table-column prop="botname" label="BOT用户名" min-width="280" />
            <el-table-column prop="token" label="Token" min-width="400" show-overflow-tooltip />

            <el-table-column prop="status" label="状态" min-width="120">
                <template #default="scope">
                    <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
                        {{ scope.row.status === 1 ? '已运行' : '未运行' }}
                    </el-tag>
                </template>
            </el-table-column>



            <el-table-column prop="createdAt" label="创建时间" width="180" sortable>
                <template #default="scope">{{ formatDateTime(scope.row.createdAt) }}</template>
            </el-table-column>
            <el-table-column prop="updatedAt" label="更新时间" width="180" sortable>
                <template #default="scope">{{ formatDateTime(scope.row.updatedAt) }}</template>
            </el-table-column>

            <el-table-column label="操作" width="280" fixed="right">
                <template #default="scope">
                    <div class="action-buttons">
                        <el-button type="primary" size="small" @click="handleEdit(scope.row)">
                            <el-icon>
                                <Edit />
                            </el-icon>编辑
                        </el-button>
                        <el-button type="success" size="small" @click="handleStart(scope.row)">
                            <el-icon>
                                <Refresh />
                            </el-icon>启动/重启
                        </el-button>
                        <el-button type="danger" size="small" @click="handleDelete(scope.row)">
                            <el-icon>
                                <Delete />
                            </el-icon>删除
                        </el-button>
                    </div>
                </template>
            </el-table-column>



        </el-table>
        <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
        <el-dialog v-model="dialogVisible" :title="dialogType === 'create' ? '新增机器人' : '编辑机器人'" width="600px"
            :close-on-click-modal="false" destroy-on-close>
            <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
                <el-form-item label="BOT用户名" prop="botname">
                    <el-input v-model="form.botname" placeholder="请输入机器人用户名（@开头）" />
                </el-form-item>
                <el-form-item label="Token" prop="token">
                    <el-input v-model="form.token" placeholder="请输入机器人Token" :readonly="dialogType === 'edit'"
                        :disabled="dialogType === 'edit'" />
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="handleSubmit">确定</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { Search, Refresh, Plus, Edit, Delete } from '@element-plus/icons-vue'
import api from '@/services/api'

export default {
    name: 'BotManager',
    components: { Search, Refresh, Plus, Edit, Delete },
    data() {
        return {
            searchForm: { botname: '' },
            tableData: [],
            currentPage: 1,
            pageSize: 20,
            total: 0,
            loading: false,
            dialogVisible: false,
            dialogType: 'create',
            form: { botname: '', token: '' },
            rules: {
                botname: [{ required: true, message: '请输入机器人用户名（@开头）', trigger: 'blur' }],
                token: [{ required: true, message: '请输入机器人Token', trigger: 'blur' }],
            }
        }
    },
    methods: {
        // 搜索功能
        onSearch() { this.currentPage = 1; this.fetchData(); },
        resetSearch() { this.searchForm = { botname: '' }; this.currentPage = 1; this.fetchData(); },
        // 获取当前用户ownerid
        getOwnerId() {
            const username = this.$store.state.user?.username || '';
            const match = username.match(/^tg_(\d{5,20})$/);
            return match ? match[1] : '';
        },
        // 获取数据
        async fetchData() {
            this.loading = true;
            try {
                const params = {
                    page: this.currentPage,
                    pageSize: this.pageSize,
                    ownerid: this.getOwnerId(),
                };
                if (this.searchForm.botname) params.botname = this.searchForm.botname;
                const response = await api.getBots(params);
                if (response.data.code === 0) {
                    this.tableData = response.data.data.records;
                    this.total = response.data.data.total;
                } else {
                    this.$message.error(response.data.message || '获取数据失败');
                }
            } catch (error) {
                console.error('获取机器人列表失败:', error);
                this.$message.error('获取数据失败');
            } finally {
                this.loading = false;
            }
        },
        handleSizeChange(val) { this.pageSize = val; this.currentPage = 1; this.fetchData(); },
        handleCurrentChange(val) { this.currentPage = val; this.fetchData(); },
        showCreateDialog() {
            this.dialogType = 'create';
            this.form = { botname: '', token: '' };
            this.dialogVisible = true;
        },
        handleEdit(row) {
            this.dialogType = 'edit';
            this.form = { ...row };
            this.dialogVisible = true;
        },
        async handleDelete(row) {
            try {
                await this.$confirm('确定要删除这个机器人吗？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' });
                const response = await api.deleteBot(row.id);
                if (response.data.code === 0) {
                    this.$message.success('删除成功');
                    this.fetchData();
                } else {
                    this.$message.error(response.data.message || '删除失败');
                }
            } catch (error) {
                if (error !== 'cancel') {
                    console.error('删除失败:', error);
                    this.$message.error('删除失败');
                }
            }
        },
        async handleStart(row) {
            try {
                const response = await api.startBot(row.id);
                if (response.data.code === 0) {
                    this.$message.success('启动/重启成功');
                    // 重新加载机器人列表
                    this.fetchData();
                } else {
                    this.$message.error(response.data.message || '启动/重启失败');
                }
            } catch (error) {
                console.error('启动/重启机器人失败:', error);
                this.$message.error('启动/重启机器人失败');
            }
        },
        async handleSubmit() {
            try {
                await this.$refs.formRef.validate();
                let response;
                const ownerid = this.getOwnerId();
                if (!ownerid) {
                    this.$message.error('无法获取当前用户ownerid');
                    return;
                }
                if (this.dialogType === 'create') {
                    response = await api.createBot({ ...this.form, ownerid });
                } else {
                    response = await api.updateBot(this.form.id, { ...this.form, ownerid });
                }
                if (response.data.code === 0) {
                    this.$message.success(this.dialogType === 'create' ? '创建成功' : '更新成功');
                    this.dialogVisible = false;
                    this.fetchData();
                } else {
                    this.$message.error(response.data.message || '操作失败');
                }
            } catch (error) {
                console.error('操作失败:', error);
                this.$message.error(error.response.data.message || '操作失败');
            }
        },
        formatDateTime(dateTime) {
            if (!dateTime) return '-';
            const date = new Date(dateTime);
            return date.toLocaleString('zh-CN');
        }
    },
    mounted() { this.fetchData(); }
}
</script>

<style scoped>
.bot-manager {
    padding: 20px;
}

.search-section {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.button-group {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.pagination {
    margin-top: 20px;
    text-align: center;
}

.dialog-footer {
    text-align: right;
}

.el-divider {
    margin: 20px 0;
}
</style>